var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrisConnectGusto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15f4a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.21,273.55V152.77H286.48v8.11A68.45,68.45,0,0,0,249.54,150a69.17,69.17,0,0,0-69,69.27c0,38.17,31,69.26,69,69.26A68.21,68.21,0,0,0,286.17,278v2.67a36.25,36.25,0,0,1-55.51,30.89l-16.22,28.53A68.75,68.75,0,0,0,250,350c38.07,0,69.47-31.09,69.47-69.27C319.21,279.3,319.32,275,319.21,273.55ZM249.44,255.8a36.43,36.43,0,1,1,36.32-36.43A36.42,36.42,0,0,1,249.44,255.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrisConnectGusto);
export default __webpack_public_path__ + "static/media/HRIS-connect-gusto.707437d6e57439efaf759c8d7114e1c0.svg";
export { ForwardRef as ReactComponent };